import { Link } from "react-router-dom";
export default function TicketsNav({props}){
    const {FirstNavbar,SecondNavbar,ThirdNavbar,Title}=props
    return(
        <div className="breadcrumbs">
            <div className="FaqNav">
                {/* <div className="Navbar">
                    <p className="breadcrumbs-Header">{FirstNavbar}</p>
                    <p className="breadcrumbs-Header">&gt;</p>
                    <p className="breadcrumbs-Header">{SecondNavbar}</p>
                    <p className="breadcrumbs-Header">&gt;</p>
                    <p className="breadcrumbs-Header">{ThirdNavbar} </p>
                </div> */}
            </div>
            <div className="FAQHeader"> <strong>{Title}</strong></div>
        </div>
    )
}